import styled, { css } from 'styled-components';
import {
  ModalBackdropStyled,
  SideSheetFooterStyled,
  SideSheetHeader,
  SideSheetClose,
  ButtonAppearance,
  Button,
} from '@bechtel/gds';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: 25%;
  margin-left: ${({ theme }) => theme.spacings[400]};
  margin-bottom: ${({ theme }) => theme.spacings[500]};
  top: ${({ theme }) => theme.spacings[500]};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    top: ${({ theme }) => theme.spacings[400]};
    margin-left: ${({ theme }) => theme.spacings[200]};
    margin-bottom: ${({ theme }) => theme.spacings[400]};
  }
`;

export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 288px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
`;

export const LabelStyled = styled.label`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  padding: ${({ theme }) => theme.spacings[500]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const SubHeader = styled(LabelStyled)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    justify-content: space-between;
  `}
`;

export const ResetButtonStyled = styled(Button)`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const FooterStyled = styled(SideSheetFooterStyled)`
  background-color: ${({ theme }) => theme.colors.blue[800]};
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
`;

export const DrawerHeader = styled(SideSheetHeader).attrs({ title: 'Backlog Filters' })`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.grey[1000]};
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
      h1 {
        font-size: ${theme.fontSizes[400]};
        font-weight: ${theme.fontWeights[600]};
      }
    `}
`;

export const DrawerClose = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.blue[800]};
      border: none;
    `}
`;
